
import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import App from './App';
import {Theme} from './theme'; // Adjust the path as necessary


const domNode = document.getElementById('root');
const root = createRoot(domNode);
root.render(
  <ThemeProvider theme={Theme}>
    <CssBaseline />
    {/* Apply baseline styles globally */}
    <App />
  </ThemeProvider>
);
